import { render, staticRenderFns } from "./signInData.vue?vue&type=template&id=163bb906&scoped=true&"
import script from "./signInData.vue?vue&type=script&lang=js&"
export * from "./signInData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163bb906",
  null
  
)

export default component.exports